define('display/copyright',["leaflet", "services/copyright", "./messageBox"], function (L, copyright, messageBox) {
    "use strict";
    return {
        addTo: function (map) {
            var tomtomAttribution = document.querySelector("#" + map.getContainer().id + " .tomtomAttribution");
            L.DomEvent.on(tomtomAttribution, "click", function () {
                    // TODO: add loading indicator
                    copyright().boundingBox(map.getBounds())
                        .callback(function (result) {
                            messageBox({content: result}).addTo(map);
                        }).go();
                }
            );
        }
    };
});
